<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <mat-chip-grid #chipGrid>
    <!-- Render selected filters as chips -->
    @for (group of selectedGroups; track group) {
      <mat-chip-row
        (removed)="removeGroup(group)">
        <span class="chip-value">{{ group?.name }}</span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }

    <!-- Input field for new filters -->
    <input
      matInput
      [formControl]="filterControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid"
      (matChipInputTokenEnd)="addFreeTextFilter($event)"
      (keydown.enter)="handleEnterKey($event)"
      placeholder="Search"
      appearance="fill"
      />
    </mat-chip-grid>

    <!-- Autocomplete for chip names -->
    <mat-autocomplete #auto (optionSelected)="selectGroup($event)" autoActiveFirstOption>
      @for (group of options | async; track group) {
        <mat-option [value]="group">
          {{ group.name }} ({{ group.key }})
        </mat-option>
      }
    </mat-autocomplete>

    <mat-hint>{{ hint }}</mat-hint>
  </mat-form-field>
